import axios from "axios";

const SendWol = async () => {

    const payload = { data: 'WAKE_Z690A' };
    axios.post('/wakeZ690', payload)
        .then((response) => { return response.data})
        .catch(() => {return "ERROR"
        ;})



}

export default SendWol;